module.exports = "pegasus_template/assets/circle-instagram.png";